import React, { useState } from "react";
import Wmbutton from "../../ui-components/wm-button/Wm.button";
import "./events.css";
import EventsSearch from "./EventsSearch";
import { useHistory } from "react-router-dom"
import { getEvents } from '../../functions/certificatesAPI';
import Spinner from '../../Components/spinner/Spinner'
import EventCard from './EventCard'
import { useQuery } from "react-query";
import ServerError from "../../Pages/error/500/ServerError";
import { ReactQueryDevtools } from 'react-query/devtools'
function Events() {
  let history = useHistory();
  const handleAddevent = () => { history.push('/i/institute/addevents') }
  const [events, setEvents] = useState([])
  const entiryEvent = useQuery(['eventEntityList', 'EVENT'], getEvents, { refetchOnWindowFocus: false, onSuccess: data => { setEvents(data.data) } })
  const [eventsSearch, setEventsSearch] = useState('')
  if(entiryEvent.isLoading) return <div className='relative w-full mt-7 flex items-center justify-center'><Spinner className="" width={50} height={50} /></div>
  if(entiryEvent.isError) return <><div><ServerError message={entiryEvent.error.response.status} /></div></>
  if(entiryEvent.isSuccess) return (
    <>
      <div className="">
        <div className="">
          <div className="flex space-x-5">
            <div className="flex-grow">
              <EventsSearch className=" ring-1 ring-gray-400 px-3 py-2" inputClass="w-full pl-2" value={eventsSearch} onSearch={(e) => setEventsSearch(e.target.value)} />
            </div>
            <div className="">
              <Wmbutton label={'Add events'} className="w-full rounded-3xl px-4" type="button" color="primary" onClick={handleAddevent} />
            </div>
          </div>
          {entiryEvent.isFetching ? <div className='relative w-full mt-7 flex items-center justify-center'><Spinner className="" width={50} height={50} /></div> : events.length > 0 ? <div className="relative w-full mt-10 grid grid-cols-4 gap-4">
            {events.filter((x) => x["event_name"].toLowerCase().includes(eventsSearch.toLowerCase())).map((data, idx) => {
              return <EventCard key={idx} eventData={data} />
            })}
          </div> : <div className="col-md-12 mt-5">
            <span className="block manpro text-xl font-semibold text-center">No certificates found</span>
          </div>}
        </div>
      </div>
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}

export default Events;
